import React, { useState, useEffect } from "react";
import "./PinnedContentTableStyles.css";
import { ReactComponent as Audio } from "../../../../../assets/icons/audio.svg";
import { ReactComponent as Article } from "../../../../../assets/icons/article.svg";
import { ReactComponent as Video } from "../../../../../assets/icons/video.svg";
import { ReactComponent as Pin } from "../../../../../assets/icons/pin.svg";
import { ContentTileColors } from "../../../../../constants/constants";
import ViewPinnedContentV2 from "./ViewPinnedContentV2";
import { normalizeMediaType, getDisplayMediaType } from "../../../../../util/helpers";

const ContentTile = ({ content_data, is_pinned = false, patientID }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const rawMediaType = content_data?.value?.media_type;
  const normalizedType = normalizeMediaType(rawMediaType);
  const displayLabel = getDisplayMediaType(rawMediaType);

  return (
    <div
      className="content-tile"
      style={{
        background: `url(${
          content_data?.value?.Thumbnail?.url ||
          content_data?.value?.Picture?.url ||
          "https://placehold.co/600x400?text=."
        }) no-repeat center/cover`,
      }}
      onClick={() => {
        setModalOpen(true);
      }}
    >
      <ViewPinnedContentV2
        modalIsOpen={isModalOpen}
        setIsOpen={() => setModalOpen(false)}
        data={content_data?.value}
        patientID={patientID}
        modalTitle={"Pin Content"}
      />
      {is_pinned && (
        <span className="d-flex w-100 justify-content-end">
          <Pin />
        </span>
      )}

      <p className="content-title">
        {content_data?.value?.Title || "Not Available"}
      </p>
      <div
        className="d-flex"
        style={{
          gap: "6px",
          position: "absolute",
          bottom: "5%",
          left: "5%",
          alignItems: "center",
        }}
      >
        <div
          className="content-tile-pill"
          style={{ color: ContentTileColors[normalizedType] }}
        >
          {normalizedType === "Audio" && (
            <Audio fill={ContentTileColors[normalizedType]} />
          )}
          {normalizedType === "Videos" && (
            <Video fill={ContentTileColors[normalizedType]} />
          )}
          {normalizedType === "Article" && (
            <Article
              fill={ContentTileColors[normalizedType]}
            />
          )}
          {displayLabel}
        </div>
        <span className="text-white">•</span>
        <small className="text-white">
          by {content_data?.value?.author || "Anonymous"}
        </small>
      </div>
    </div>
  );
};

export default ContentTile;
